import { Component, OnInit, ViewChild, Input, ElementRef } from "@angular/core";
import { MatExpansionPanel } from "@angular/material/expansion"; 
import { MatChipList } from "@angular/material/chips"; 
import { MatAutocomplete, MatAutocompleteTrigger } from "@angular/material/autocomplete"; 
import { ConfirmDialogComponent } from "src/app/services/dialog/confirm-dialog/confirm-dialog.component";
import { CampaignsService } from "src/app/pages/campaign-module/campaigns/campaigns.service";
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from "@angular/forms";
import { DistributionPromoMechanic } from "src/app/model/distribution-promo-mechanic";
import { DistributionPromoDetailSku } from "src/app/model/distribution-promo-sku";
import { DistributionPromoDetail } from "src/app/model/distribution-promo-detail";
import { ConstantsHelper } from "src/assets/constants/constants.helper";

import { startWith, map, finalize, takeUntil, catchError, debounceTime, distinctUntilChanged, tap, filter } from "rxjs/operators";
import { DialogService, HelperService, LanguageService } from "src/app/services";
import { of as observableOf, Observable, forkJoin, fromEvent } from "rxjs";
import { PromoCondition } from "src/app/model/promo-condition";
import { CopierComponent } from "../copier/copier.component";
import { environment } from "src/environments/environment";
import { PATTERN_NUMERIC } from "src/app/utils/constant";
import { Category } from "src/app/model/category";
import { Brand } from "src/app/model/brand";
import { Sku } from "src/app/model/sku";
import * as moment from "moment";
import * as _ from "lodash";

@Component({
  selector: "esc-step-three",
  templateUrl: "./step-three.component.html",
  styleUrls: ["./step-three.component.scss"]
})
export class StepThreeComponent implements OnInit {
  @ViewChild("expansionPanel") expansionPanel: MatExpansionPanel;
  @ViewChild("auto") matAutocomplete: MatAutocomplete;
  @ViewChild("brandAC") brandACRef: MatAutocomplete;
  @ViewChild(MatAutocompleteTrigger) matAutocompleteACTr: MatAutocompleteTrigger;
  @ViewChild(MatAutocompleteTrigger) brandACTr: MatAutocompleteTrigger;
  @ViewChild('chipList') chipList: MatChipList;
  @ViewChild('chipsBrand') chipsBrand: MatChipList;
  @ViewChild('itemInput') itemInput: ElementRef;
  @ViewChild('escCopier') escCopier: CopierComponent;

  @Input() viewMode;
  @Input() distributionData;
  @Input() did_generate;
  @Input() status;
  
  dateRangeFrom: Date;
  dateRangeTo: Date;
  condition: PromoCondition;
  
  distribution;
  private distributionSkus;

  CopiedCondition: PromoCondition;
  editMode = false;
  distribution_promo_id = 0;
  conditionDetailRows: any[] = [];
  promoDetails: DistributionPromoDetail[] = new Array<DistributionPromoDetail>();
  skuBrandCategory = [];
  promoMechanics: DistributionPromoMechanic[] = new Array<DistributionPromoMechanic>();

  maxSKUresetPeriod: any[] = [];
  resetDayOptions: any[] = [];
  discountTypes: any[] = [];
  roundingOptions: any[] = [];
  applyDiscountToOption: any[] = [];
  tierBaseDiscountoptions: any[] = []
  periodTierOptions: any[] = []
  concurrentRequest = [];
  public mechanicForms: FormGroup;
  public formGroup: FormGroup;
  public formGroupDescription: FormGroup;
  private constants = ConstantsHelper;
  get displayedColumns(): string[] {
    if (this.isSelectedDiscountTierNone) {
      return ["Sequence", "Min", "Max", "Discount"];
    }
    return ["Sequence", "From", "To", "Min", "Max", "Discount"];
  }
  displayedColumnsEdit: string[] = ["Sequence", "From", "FromInfinite", "To", "ToInfinite", "Min", "MinInfinite", "Max", "MaxInfinite", "Discount"];
  public loading = {
    brand: false,
    item: false,
    error: false,
  }
  public filters;
  defaultOptionSku: DistributionPromoDetailSku;
  defaultOptionBrand: DistributionPromoDetailSku;

  // selectedItems: DistributionPromoDetailSku[] = new Array<DistributionPromoDetailSku>();
  multiSelect = {
    selectedBrands: [],
    selectedItems: [],
  }

  filteredBrands: Observable<DistributionPromoDetailSku[]>;
  filteredItems: Observable<DistributionPromoDetailSku[]>;
  
  lastFilter: string = "";
  removable = true;
  defaultRounding = "";

  categories = [];
  brands = [];
  items = [];
  
  originalSourceItem = [] // instantiated on getSourceData('item'), we need to store in memory the whole item list to handle 'All' apply to
  originalSourceBrand = [] // instantiated on getSourceData('brand'), we need to store in memory the whole brand list to handle 'All' apply toItem

  promoSku;
  promoDetailId;
  minDate;
  maxDate;
  distributionPromoDetail: DistributionPromoDetail[] = new Array<DistributionPromoDetail>();
  networkErrMsg = this.languageService.getTranslation("MSG_ERROR_NETWORK_CONNECTION", {});

  constructor(
    private fb: FormBuilder, 
    private helper: HelperService, 
    private dialogService: DialogService, 
    public languageService: LanguageService,
    private campaignsService: CampaignsService,
  ) {}

  // DEV NOTES: 
  // In campaign-wizard prepareStepTwoData, values for categories, brands, items lists are set
  ngOnInit() {
    this.initForm();
    this.setDropDownOptions();
    this.initDefaultOptionSku();
    this.initDefaultOptionBrand();

    this.filters = _.cloneDeep(INITIAL_OPTIONS);
    this.condition = new PromoCondition();
  }

  getConditions() {
    const stepTwoResponse = this.campaignsService.getStepTwoResponse();

    //added by kiko 3.feb.2020 - init as empty array
    this.promoDetails = [];

    // Initial distribution data from step 2
    this.distribution = stepTwoResponse ? stepTwoResponse : this.distributionData;

    // Initial distribution SKUs to be used for filtering
    this.distributionSkus = this.distribution.skus ? this.distribution.skus : [];

    //added by kiko 11.feb.2020 - set min and max date
    this.minDate = new Date(_.get(this.distribution, 'start_date'));
    this.maxDate = new Date(_.get(this.distribution, 'end_date'));

    let loadingDialog = this.dialogService.loading();

    this.campaignsService.getDistributionPromo(this.distribution["id"]).pipe(
      catchError((err) => {
        console.error(err);
        return observableOf(null);
      }),
      finalize(() => {
        return observableOf({});
      }))
      .subscribe(result => {

      if(environment.showLogs) {
        console.log(result);
      }

      if (result.value == "Success") {
        this.distribution_promo_id = _.get(result.data[0], 'id') || 0;

        this.formGroupDescription.get("maxSKU").setValue(result.data[0].max_sku_qty);
        this.formGroupDescription.get("maxSKUResetPeriodQty").setValue(result.data[0].max_sku_reset_period_qty);
        this.formGroupDescription.get("maxSKUresetPeriod").setValue(result.data[0].max_sku_reset_period);
        this.formGroupDescription.get("decimal").setValue(result.data[0].discount_compute_decimal_places);

        if (result.data[0].discount_type_id == this.constants.DISCOUNT_TYPES[0].value) {
          this.formGroupDescription.get("discountTypeSelect").setValue(this.constants.DISCOUNT_TYPES[0].value);
        } else if (result.data[0].discount_type_id == this.constants.DISCOUNT_TYPES[1].value) {
          this.formGroupDescription.get("discountTypeSelect").setValue(this.constants.DISCOUNT_TYPES[1].value);
        }

        this.formGroupDescription.get("discountRateSelect").setValue(result.data[0].discount_compute_rounding);
        this.formGroupDescription.get("accumulatedPurchase").setValue(result.data[0].purchase_is_accumulated);
        const discountTierValue = result.data[0].discount_tier?.toLowerCase() ?? 'None';
        this.formGroupDescription.get("discountTier").setValue(discountTierValue);
        this.formGroupDescription.get("mechanicPeriodBasis").setValue(result.data[0].mechanic_period_basis)

        console.log(this.formGroupDescription.get('mechanicPeriodBasis'));

        this.campaignsService.getDistributionPromoDetailList(result.data[0].distribution_id, 0, 0, "").pipe(
          catchError((err) => {
            console.error(err);
            return observableOf(null);
          }),
          finalize(() => {
            return observableOf({});
          }))
          .subscribe(detailresult => {
          if(environment.showLogs) {
            console.log(detailresult);
          }
          if (detailresult.value == "Success") {
            this.formGroup.get('priority').setValue(detailresult.data.length + 1)
            for (const [index, det] of detailresult.data.entries()) {
              let addedDistributionPromoDetail = new DistributionPromoDetail();

              addedDistributionPromoDetail._distribution_promo_sku = [];
              addedDistributionPromoDetail._distribution_promo_brand = [];
              addedDistributionPromoDetail._id = det.id;
              addedDistributionPromoDetail._temp_id = index;
              addedDistributionPromoDetail._description = det.description;
              addedDistributionPromoDetail._priority = det.priority;
              addedDistributionPromoDetail._use_distribution_start_end_date =  det.is_distribution_date ? 1 : 0; 
              addedDistributionPromoDetail._start_date = det.start_date && moment(new Date(det.start_date)).isValid() ? moment(det.start_date).format("YYYY-MM-DD") : null;
              addedDistributionPromoDetail._end_date = det.end_date && moment(new Date(det.end_date)).isValid() ? moment(det.end_date).format("YYYY-MM-DD") : null;
              addedDistributionPromoDetail._capacity = det.capacity;
              addedDistributionPromoDetail._capacity_reset_period = det.capacity_reset_period;
              addedDistributionPromoDetail._capacity_reset_period_qty = det.capacity_reset_period_qty;
              addedDistributionPromoDetail._capacity_reset_day = det.capacity_reset_day;
              addedDistributionPromoDetail._mechanic_period = det.mechanic_period;
              addedDistributionPromoDetail._apply_for_every_nth_pcs = det.apply_for_every_nth_pcs;
              addedDistributionPromoDetail._apply_discount_to = det.apply_discount_to;
          
              this.concurrentRequest = [];
              this.concurrentRequest.push(this.campaignsService.getDistributionPromoDetailSKUList(_.get(this.distribution, "id") || 0, det.id));
              this.concurrentRequest.push(this.campaignsService.getDistributionPromoDetailMechanicList(_.get(this.distribution, "id") || 0, det.id));
              
              forkJoin(...this.concurrentRequest)
                .pipe(finalize(() => {
                  loadingDialog.close();
                  return observableOf(null);
                }),
                catchError((err) => {
                  console.error(err);
                  return observableOf(null);
                }))
                .subscribe(res => {
                  if(environment.showLogs) {
                    console.log(res);
                  }
                  loadingDialog.close();

                  let tempData = res.map((e:any) => {
                    return e.data;
                  });

                  const promoDetailSKUList = tempData[0]; // Get response of getDistributionPromoDetailSKUList(), contains SKUs of distribution_promo_detail                              
                  const promoDetailMechanicList = tempData[1]; // Get response of getDistributionPromoDetailMechanicList(), contains mechanics of distribution_promo_detail

                  // Process promoDetailMechanicList
                  if (promoDetailMechanicList) {
                    const tempMechHolder: any[] = [];

                    for (let mech in promoDetailMechanicList) {
                      let newMech = new DistributionPromoMechanic();
                      newMech._id = promoDetailMechanicList[mech]["id"];
                      newMech._sequence = promoDetailMechanicList[mech]["sequence"];
                      newMech._mechanic_period_from_qty = promoDetailMechanicList[mech]["mechanic_period_from_qty"];
                      newMech._mechanic_period_to_qty = promoDetailMechanicList[mech]["mechanic_period_to_qty"];
                      newMech._mechanic_transaction_count_from_qty = promoDetailMechanicList[mech]["mechanic_transaction_count_from_qty"];
                      newMech._mechanic_transaction_count_to_qty = promoDetailMechanicList[mech]["mechanic_transaction_count_to_qty"];
                      newMech._purchase_min = promoDetailMechanicList[mech]["purchase_min"];
                      newMech._purchase_max = promoDetailMechanicList[mech]["purchase_max"];
                      newMech._discount_value = promoDetailMechanicList[mech]["discount_value"];

                      tempMechHolder.push(newMech);
                    }
                    addedDistributionPromoDetail._distribution_promo_mechanic = tempMechHolder;
                  }

                  // Process promoDetailSKUList
                  if (promoDetailSKUList) {
                    this.promoSku = promoDetailSKUList;
                    this.promoDetailId = promoDetailSKUList[0]["distribution_promo_detail_id"];

                    // Iterate promoDetailSKUList
                    for (let currentSku of promoDetailSKUList) {
                      const skuMode = currentSku["mode"];

                      if (skuMode == "SKU") {
                        // Parse currentSku to get sku
                        const newSku = this.createSku(currentSku);
                        addedDistributionPromoDetail._distribution_promo_sku.push(newSku);
                      }

                      if (skuMode == "BRAND") {
                        // Parse currentSku to get brand, sku
                        const newBrand = this.createBrand(currentSku);
                        const newSku = this.createSku(currentSku);

                        // Concatenate unique brands
                        if (!addedDistributionPromoDetail._distribution_promo_brand.some(b => b._brand._id === newBrand._brand._id)) {
                          addedDistributionPromoDetail._distribution_promo_brand.push(newBrand);
                        }
                        addedDistributionPromoDetail._distribution_promo_sku.push(newSku);
                      }

                      if (skuMode == "CATEGORY") {
                        // Parse currentSku to get category, brand, sku
                        const newCategory = this.createCategory(currentSku);
                        const newBrand = this.createBrand(currentSku);
                        const newSku = this.createSku(currentSku);

                        // Concatenate unique categories
                        if (!addedDistributionPromoDetail._distribution_promo_category.some(c => c._category._id === newCategory._category._id)) {
                          addedDistributionPromoDetail._distribution_promo_category.push(newCategory);
                        }
                        // Concatenate unique brands
                        if (!addedDistributionPromoDetail._distribution_promo_brand.some(b => b._brand._id === newBrand._brand._id)) {
                          addedDistributionPromoDetail._distribution_promo_brand.push(newBrand);
                        }
                        addedDistributionPromoDetail._distribution_promo_sku.push(newSku);
                      }
                    }
                  }

                  this.promoDetails = this.promoDetails.concat(addedDistributionPromoDetail);
                  this.condition._distribution_promo_detail = this.promoDetails;

                });
            }
          }
        });
        
        return observableOf(null);
      } 

      // close dialog if no result
      else {
        loadingDialog.close();
      }
      return observableOf(null);
    });
  }

  private createSku(promoSku): DistributionPromoDetailSku {
    const newSku = new Sku();
    newSku._id = promoSku.sku.id;
    newSku._description = promoSku.sku.description;
  
    return new DistributionPromoDetailSku(
      promoSku.id,
      promoSku.distribution_promo_detail_id,
      null,
      null,
      newSku
    );
  }

  private createBrand(promoSku): DistributionPromoDetailSku {
    const newBrand = new Brand();
    newBrand._id = promoSku.brand.id;
    newBrand._description = promoSku.brand.description;
  
    return new DistributionPromoDetailSku(
      promoSku.id,
      promoSku.distribution_promo_detail_id,
      null,
      newBrand,
      null
    );
  }

  private createCategory(promoSku): DistributionPromoDetailSku {
    const newCategory = new Category();
    newCategory._id = promoSku.category.id;
    newCategory._description = promoSku.category.description;
  
    return new DistributionPromoDetailSku(
      promoSku.id,
      promoSku.distribution_promo_detail_id,
      newCategory,
      null,
      null
    );
  }

  get mechanicFormControls() {
    return this.mechanicForms.controls;
  }

  get mechanicFormArray() {
    return this.mechanicForms.controls["items"] as FormArray;
  }
  
  // Called once upon ngOnInit as of 11/26/25 
  initForm() {
    this.mechanicForms = this.fb.group({
      items: new FormArray([])
    });

    this.formGroup = this.fb.group({
      id: null,
      temp_id: null,
      description: new FormControl(null, Validators.compose([Validators.required, Validators.maxLength(255)])),
      applyToBrand: [null], 
      applyToBrandInput: [null],
      applyTo: [null, [Validators.required,this.helper.chipsRequiredValidator]],
      applyToInput: [null],
      resetPeriodNo: [null, [Validators.maxLength(3), Validators.min(1), Validators.pattern(PATTERN_NUMERIC)]],
      resetPeriod: [this.constants.MAX_SKU_RESET_PERIOD[0].value, Validators.required],
      resetDay: [this.constants.RESET_DAY_OPTIONS[0].value, Validators.required],
      priority: [{value: null, disabled: true}, Validators.compose([Validators.maxLength(2), Validators.required,  Validators.pattern(PATTERN_NUMERIC), Validators.min(1)])],
      cap: ["Infinite", Validators.compose([Validators.min(1), Validators.maxLength(4), Validators.required, this.helper.validateNumbersOnly])],
      capInfinite: [true],
      nthPiece: [1, Validators.compose([Validators.maxLength(3), Validators.required, this.helper.validateNumbersOnly, Validators.min(1)])],
      applyDiscountTo: [this.constants.APPLY_DISCOUNT_TO_OPTIONS[0].value, Validators.required],
      periodTier: [this.constants.MAX_SKU_RESET_PERIOD[0].value, Validators.required],
      useDistributionDates: [true],
      dateRangeFrom: [null],
      dateRangeTo: [null]
    });

    //disable bec capInfinite default value is 'true'
    this.formGroup.get('cap').disable();

    //disable bec resetperiod value is 'none'
    this.formGroup.get('resetPeriodNo').disable();
    this.formGroup.get('resetDay').disable();

    this.formGroupDescription = this.fb.group({
      maxSKU: new FormControl({value: null, disabled: true}, Validators.compose([Validators.maxLength(2), this.helper.validateNumbersOnly, Validators.min(1)])),
      maxSKUResetPeriodQty: new FormControl({value: null, disabled: true}, Validators.compose([this.helper.validateNumbersOnly, Validators.maxLength(2), Validators.min(1), Validators.required])),
      maxSKUresetPeriod: new FormControl({value: null, disabled: true}, [Validators.required]),
      decimal: new FormControl(2, Validators.compose([Validators.required, this.helper.validateNumbersOnly, Validators.maxLength(1)])),
      discountTypeSelect: new FormControl(this.constants.DISCOUNT_TYPES[0].value, [Validators.required]),
      discountRateSelect: new FormControl(this.constants.ROUDING_OPTIONS[0].value, [Validators.required]),
      discountTier: new FormControl(this.constants.TIER_BASE_DISCOUNT_OPTIONS[0].value, [Validators.required]),
      mechanicPeriodBasis: new FormControl(this.constants.PERIOD_TIER_OPTIONS[0].value, [Validators.required]),
      accumulatedPurchase: [{value: null, disabled: true}]
    });

    // disabled as per QATS #175
    // maxSKU, maxSKUResetPeriod, maxSKUResetPeriodQty, accumulatedPurchase, priority

    //disable bec discountTypeSelect value is 'Discount Amount'
    this.formGroupDescription.get('discountRateSelect').disable();
    this.formGroupDescription.get('decimal').disable();

    if(this.viewMode) {
      this.mechanicForms.disable();
      this.formGroup.disable();
      this.formGroupDescription.disable();
    }
  }

  hasInfiniteMechanic(mechanic) {
    let valueArray = mechanic.map(e => {
      return _.get(e, 'value')
    })

    if (this.isSelectedDiscountTierTransactionCount) {
      const lastValue = valueArray[valueArray.length - 1];
      if (lastValue?.toInfinite) return true;

      return this.mechanicFormArray.controls.length > 0 && !this.mechanicFormArray.controls[this.mechanicFormArray.controls.length - 1].valid
    }

    return !!_.find(valueArray, { maxInfinite: true }); 
  }

  validateFromToValues(mechanic) {
    if (!this.isSelectedDiscountTierTransactionCount) return;

    const valueArray = mechanic.map(e => {
      return _.get(e, 'value')
    })

    let groupBySequence = _.groupBy(valueArray, 'sequence');
    let groupBySequenceArray = [];

    for(let i in groupBySequence) {
      groupBySequenceArray.push(groupBySequence[i][0]);
    }

    for(let i = 0; i < groupBySequenceArray.length; i++) {
      if(i>0) {
        if(_.parseInt(groupBySequenceArray[i].from) <= _.parseInt(groupBySequenceArray[i-1].to)) {
          mechanic[i].controls.from.setErrors(
            { smaller: true }
          )
        } 
        else {
          mechanic[i].controls.from.setErrors(null)
        }
      }
    }
  }

  validateMinMaxValues(mechanic) {
    if (this.isSelectedDiscountTierTransactionCount) return;

    let valueArray = mechanic.map(e => {
      return _.get(e, 'value')
    })

    let groupBySequence = _.groupBy(valueArray, 'sequence');
    let groupBySequenceArray = [];

    for(let i in groupBySequence) {
      groupBySequenceArray.push(groupBySequence[i][0]);
    }

    for(let i = 0; i < groupBySequenceArray.length; i++) {
      if(i>0) {
        if(groupBySequenceArray[i-1].maxInfinite == true) {
          mechanic[i].controls.min.setErrors(
            { notAfterInfinite: true }
          )
        }
        else if(_.parseInt(groupBySequenceArray[i].min) <= _.parseInt(groupBySequenceArray[i-1].max)) {
          mechanic[i].controls.min.setErrors(
            { smaller: true }
          )
        } 
        else {
          mechanic[i].controls.min.setErrors(null)
        }
      }
    }
  }

  addCondition(condition, mechanic) {
    if (this.formGroupDescription.get('discountTier').value === null) {
      condition.get('periodTier').setValue('None')

    } else {
      condition.get('periodTier').setValue(this.formGroupDescription.get('mechanicPeriodBasis').value)
    }
    let mechanicFormArrayIsValid = true;
    let promoCondition = this.formGroup.getRawValue()

    let seqArr = [];
    seqArr = mechanic.map(e => {
      return parseInt(_.get(e, 'value.sequence'))
    })

    seqArr.filter((item, idx) => {
      if(seqArr.indexOf(item) != idx) {
        mechanic[idx].controls.sequence.setErrors(
          { duplicateSequence: true }
        )
      } else {
        mechanic[idx].controls.sequence.setErrors(null)
      }
    })

    this.validateFromToValues(mechanic);
    this.validateMinMaxValues(mechanic);

    for(let i in mechanic) {
      if(!mechanic[i].valid) {
        mechanicFormArrayIsValid = false;
        break;
      }
    }

    if (this.formGroup.valid && mechanicFormArrayIsValid && promoCondition["applyDiscountTo"].length > 0 && this.conditionDetailRows.length > 0) {
      if (this.promoDetails.length == 0) {
        this.confirmAddItem(promoCondition, mechanic);
        return;
      }
      if (this.validateItems(promoCondition.temp_id, promoCondition.applyTo)) {
        this.confirmAddItem(promoCondition, mechanic);
      } else {
        this.dialogService.openDialog(ConfirmDialogComponent, {
          width: "400px",
          autoFocus: true,
          disableClose: true,
          data: {
            title: this.languageService.getTranslation("MSG_WIZARD_INVALID_ITEM", {}),
            message: this.languageService.getTranslation("MSG_WIZARD_QMARK", {}),
            button: this.languageService.getTranslation("LABEL_YES", {}),
            cancelButton: this.languageService.getTranslation("LABEL_NO", {}),
          }
        });
      }
    } else {
      if(!mechanic[0]){
        this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_WIZARD_ADD_MECHANIC", {}));
      }

      for (let ctrl in this.formGroup.controls) {
        if(!this.formGroup.controls[ctrl].valid) {
          console.log(ctrl, this.formGroup.controls[ctrl])
          if(ctrl == 'applyTo') {
            this.chipList.errorState = true
          }
        } else {
          if(ctrl == 'applyTo') {
            this.chipList.errorState = false
          }
        }
      }
   
      if(this.formGroup && !this.formGroup.valid) {
        for (let ctrl in this.formGroup.controls) {
          this.formGroup.controls[ctrl].markAsTouched();
          
        }
        this.scrollTo(document.getElementById("formWithAcordion"));
      }
      /* kiko 7.Feb.2020
      * added mechanic[0] form checking
      */
      if(!mechanicFormArrayIsValid) {
        for(let form in mechanic) {
          for (let ctrl in mechanic[form]['controls']) {
            mechanic[form]['controls'][ctrl].markAsTouched();
          }
        }
      }
    }
  }

  confirmAddItem(condition, mechanic) {
    this.dialogService
      .openDialog(ConfirmDialogComponent, {
        width: "400px",
        autoFocus: true,
        disableClose: true,
        data: {
          title: this.languageService.getTranslation("MSG_CONFIRM_ACTION", {}),
          message: this.languageService.getTranslation("MSG_WIZARD_ADD_CONDITION", {}),
          button: this.languageService.getTranslation("LABEL_YES", {}),
          cancelButton: this.languageService.getTranslation("LABEL_NO", {}),
        }
      })
      .afterClosed()
      .subscribe(result => {
        if (result) {
          //make method to build promo detail
          this.buildPromoDetailForAddItem(condition, mechanic);
        }
      });
  }

  buildPromoDetailForAddItem(details?, mechanics?: DistributionPromoMechanic) {
    let addedDistributionPromoDetail = new DistributionPromoDetail();

    // Set dates if not existing (encountered when new promo detail)
    let promoDetailStartDate;
    if (details["dateRangeFrom"]) {
      promoDetailStartDate = moment(details["dateRangeFrom"]).format("YYYY-MM-DD");
    } else {
      promoDetailStartDate = moment(this.minDate).format("YYYY-MM-DD");
    }

    let promoDetailEndDate;
    if (details["dateRangeTo"]) {
      promoDetailEndDate = moment(details["dateRangeTo"]).format("YYYY-MM-DD");
    } else {
      promoDetailEndDate = moment(this.maxDate).format("YYYY-MM-DD");
    }
     
    addedDistributionPromoDetail._id = details["id"] || 0; //always 0 for new entry
    addedDistributionPromoDetail._temp_id = details["temp_id"] || _.size(this.promoDetails)
    addedDistributionPromoDetail._use_distribution_start_end_date = details["useDistributionDates"] ? 1 : 0;
    addedDistributionPromoDetail._description = details["description"];
    addedDistributionPromoDetail._priority = details["priority"] || _.size(this.promoDetails) + 1;
    addedDistributionPromoDetail._start_date = promoDetailStartDate;
    addedDistributionPromoDetail._end_date = promoDetailEndDate;
    addedDistributionPromoDetail._capacity = _.get(details, "capInfinite") ? -1 : _.get(details, "cap");
    addedDistributionPromoDetail._capacity_reset_period = details["resetPeriod"] || null;
    addedDistributionPromoDetail._capacity_reset_period_qty = _.get(details, "resetPeriodNo") || null;
    addedDistributionPromoDetail._capacity_reset_day = _.get(details, "resetDay") || "None";
    addedDistributionPromoDetail._mechanic_period = details["periodTier"] || null;
    addedDistributionPromoDetail._apply_for_every_nth_pcs = _.get(details, 'nthPiece') || 1;
    addedDistributionPromoDetail._apply_discount_to = details["applyDiscountTo"] || null;

    let tempMechHolder: any[] = [];
    for (let entry in mechanics) {
      let newMech = new DistributionPromoMechanic();
      newMech._id = _.get(mechanics[entry], 'value.id') || 0;
      newMech._sequence = _.get(mechanics[entry], 'value.sequence');

      /* 
       * modified by kiko 3.feb.2020. added '-1' value if infinite is checked 
       * modified by kiko 7.feb.2020. changed how data is retrieved 
      */
      const fromValue = _.get(mechanics[entry], 'value.from') > 0 ? _.get(mechanics[entry], 'value.from') : -1;
      const toValue = _.get(mechanics[entry], 'value.to') > 0 ? _.get(mechanics[entry], 'value.to') : -1;

      // Default Values
      newMech._mechanic_period_from_qty = -1;
      newMech._mechanic_period_to_qty = -1;
      newMech._mechanic_transaction_count_from_qty = -1;
      newMech._mechanic_transaction_count_to_qty = -1;

      if (this.tierBaseDiscountSelect === 'period') {
        newMech._mechanic_period_from_qty = fromValue;
        newMech._mechanic_period_to_qty = toValue;
      } else if (this.isSelectedDiscountTierTransactionCount) {
        newMech._mechanic_transaction_count_from_qty = fromValue;
        newMech._mechanic_transaction_count_to_qty = toValue;
      }

      // newMech._purchase_min = _.get(mechanics[entry].get("minInfinite"), 'value') ? -1 : mechanics[entry].get("min").value;
      newMech._purchase_min = _.get(mechanics[entry], 'value.min') > 0 ? _.get(mechanics[entry], 'value.min') : -1;
      newMech._purchase_max = _.get(mechanics[entry], 'value.max') > 0 ? _.get(mechanics[entry], 'value.max') : -1;
      newMech._discount_value = Number(_.get(mechanics[entry], 'value.discount'))
      tempMechHolder = tempMechHolder.concat(newMech);
    }
    this.conditionDetailRows = [];

    addedDistributionPromoDetail._distribution_promo_mechanic = tempMechHolder;

    const selectedBrandIsAll = _.get(this.multiSelect['selectedBrands'][0], 'brand.id') == 0
    const selectedItemIsAll = _.get(this.multiSelect['selectedItems'][0], 'sku.id') == 0

    if (selectedBrandIsAll) {
      const brands:DistributionPromoDetailSku[] = []
      for (const brand of this.originalSourceBrand) {
        brands.push(brand);
      }
      addedDistributionPromoDetail._distribution_promo_brand = brands
    } else {
      addedDistributionPromoDetail._distribution_promo_brand = this.multiSelect['selectedBrands']
    }

    if (selectedItemIsAll) {
      const items:DistributionPromoDetailSku[] = []
      for (const item of this.originalSourceItem) {
        // Filter out items under the selected brands
        const itemBrandId = item.brand.id;

        // Only filter if there are selected brands and not "all"
        const shouldFilterByBrand = this.multiSelect['selectedBrands'].length > 0 && this.multiSelect['selectedBrands'][0].brand.id !== 0;

        const exists = shouldFilterByBrand
          ? this.multiSelect['selectedBrands'].some(b => b.brand.id === itemBrandId)
          : true; // if no selected brands, always include

        if (exists) {
          items.push(item);
        }
      }

      addedDistributionPromoDetail._distribution_promo_sku = items
    } else {
      addedDistributionPromoDetail._distribution_promo_sku = this.multiSelect['selectedItems']
    }     

    // addedDistributionPromoDetail._distribution_promo_brand = _.get(this.multiSelect['selectedBrands'][0], 'brand.id') == 0 ? this.brands.slice(1, this.brands.length) : this.multiSelect['selectedBrands'];
    // addedDistributionPromoDetail._distribution_promo_sku = _.get(this.multiSelect['selectedItems'][0], 'sku.id') == 0 ? this.items.slice(1, this.items.length) : this.multiSelect['selectedItems'];
    
    this.promoDetails.push(addedDistributionPromoDetail)

    this.editMode = false;
    this.multiSelect['selectedItems'] = [];
    this.multiSelect['selectedBrands'] = [];

    if (_.get(this.distribution, 'distribution_sku_mode') != "SKU") {
      this.items = []
    }

    this.condition._distribution_promo_detail = this.promoDetails;
    this.formGroup.get('periodTier').enable();
    this.formGroup.get('nthPiece').enable();
    this.formGroupDescription.get('discountTypeSelect').enable();
    this.formGroupDescription.get('discountTier').enable();
    this.formGroupDescription.get('mechanicPeriodBasis').enable();
    // details.reset();
    this.resetForm();
    this.mechanicFormArray.reset();
    this.items.forEach(e => {
      e.selected = false;
    })
    this.brands.forEach(e => {
      e.selected = false;
    })
    this.mechanicForms.controls.items["controls"] = [];
    this.expansionPanel.close();

    console.log('buildPromoDetailForAddItem this.promoDetails', this.promoDetails)
  }

  resetForm() {
    this.formGroup.get('description').setValue(null, {emitEvent: false});
    this.formGroup.get('applyToBrand').setValue(null, {emitEvent: false});
    this.formGroup.get('applyTo').setValue(null);
    this.formGroup.get('applyToBrandInput').setValue(null);
    this.formGroup.get('applyToInput').setValue(null);
    this.formGroup.get('resetPeriodNo').setValue(null);
    this.formGroup.get('resetPeriod').setValue(this.constants.MAX_SKU_RESET_PERIOD[0].value);
    this.formGroup.get('resetDay').setValue(this.constants.RESET_DAY_OPTIONS[0].value);
    this.formGroup.get('priority').setValue(this.promoDetails.length + 1);
    this.formGroup.get('cap').setValue(null);
    this.formGroup.get('nthPiece').setValue(1);
    this.formGroup.get('applyDiscountTo').setValue(this.constants.APPLY_DISCOUNT_TO_OPTIONS[0].value);
    this.formGroup.get('periodTier').setValue(this.constants.MAX_SKU_RESET_PERIOD[0].value);
    this.formGroup.get('useDistributionDates').setValue(true);
    this.formGroup.get('dateRangeFrom').setValue(null);
    this.formGroup.get('dateRangeTo').setValue(null);
    
    this.formGroup.get('description').enable({emitEvent: false})
    this.formGroup.get('resetPeriod').enable({emitEvent: false})
    if (_.toLower(this.status) != 'ongoing' && this.did_generate != 1) {
      this.formGroup.get('nthPiece').enable({emitEvent: false})
      this.formGroup.get('applyDiscountTo').enable({emitEvent: false})
      this.formGroup.get('periodTier').enable({emitEvent: false})
      this.formGroup.get('capInfinite').enable({emitEvent: false})
      this.formGroup.get('useDistributionDates').enable({emitEvent: false})
    }
    this.formGroup.markAsUntouched();
  }

  // Unused as of 11/26/25 
  collectSkus() {
     // 9-jun-2020 kiko ALWAYS SEND 0 for promoSkuId; process is host will always delete if existing and then insert new records in distribution_promo_detail_sku

    this.skuBrandCategory = [];
    if (_.get(this.distribution, 'distribution_sku_mode') == "SKU") {
      for (let item in this.distribution.skus) {
        let newsku = new Sku()
        newsku._id = this.distribution.skus[item]["id"]
        newsku._description = this.distribution.skus[item]["description"]
        // let promoSkuId = _.get(this, 'promoSku') ? _.get(this.promoSku[item], 'id') : 0;
        let promoSkuId = 0;
        let newItem: DistributionPromoDetailSku = new DistributionPromoDetailSku(promoSkuId, _.get(this, 'promoDetailId') || 0, null, null, newsku);
        this.skuBrandCategory = this.skuBrandCategory.concat(newItem);
      }
    } else if (_.get(this.distribution, 'distribution_sku_mode') == "BRAND") {
      for (let item in this.distribution.brands) {
        let newBrand = new Brand()
        newBrand._id = this.distribution.brands[item]["id"]
        newBrand._description = this.distribution.brands[item]["description"]
        // let promoSkuId = _.get(this, 'promoSku') ? _.get(this.promoSku[item], 'id') : 0;
        let promoSkuId = 0;
        let newItem: DistributionPromoDetailSku = new DistributionPromoDetailSku(promoSkuId, _.get(this, 'promoDetailId') || 0, null, newBrand, null);
        this.skuBrandCategory = this.skuBrandCategory.concat(newItem);
      }
    } else if (_.get(this.distribution, 'distribution_sku_mode') == "CATEGORY") {
      for (let item in this.distribution.categories) {
        let newCat = new Category()
        newCat._id = this.distribution.categories[item]["id"]
        newCat._description = this.distribution.categories[item]["description"]
        // let promoSkuId = _.get(this, 'promoSku') ? _.get(this.promoSku[item], 'id') : 0;
        let promoSkuId = 0;
        let newItem: DistributionPromoDetailSku = new DistributionPromoDetailSku(promoSkuId, _.get(this, 'promoDetailId') || 0, newCat, null, null);
        this.skuBrandCategory = this.skuBrandCategory.concat(newItem);
      }
    }
  }

  addRow(forms) {
    this.formGroup.get('nthPiece').disable();
    this.formGroupDescription.get('discountTypeSelect').disable();
    this.formGroupDescription.get('discountTier').disable();
    this.formGroupDescription.get('mechanicPeriodBasis').disable();
    if (forms.length == 0 || forms[forms.length - 1].valid) {
      this.addItem(null);
    }
  }

  createItem(index, data = null): FormGroup {
    let to = new FormControl(data?._mechanic_period_to_qty || null, Validators.compose([Validators.min(1), Validators.maxLength(3), this.helper.validateNumbersOnly, Validators.required]));
    to.valueChanges.subscribe((value) => {
      if((value && this.mechanicFormArray["controls"][index]["controls"]["from"].value) && (value < this.mechanicFormArray["controls"][index]["controls"]["from"].value)) {
        let val = _.cloneDeep(this.mechanicFormArray["controls"][index]["controls"]["from"].value);
        this.mechanicFormArray["controls"][index]["controls"]["from"].setValue(null);
        this.mechanicFormArray["controls"][index]["controls"]["from"].setValue(val);
      } 
      //update display value if correct
      else if (value >= this.mechanicFormArray["controls"][index]["controls"]["from"].value) {
        let val = _.cloneDeep(this.mechanicFormArray["controls"][index]["controls"]["from"].value);
        this.mechanicFormArray["controls"][index]["controls"]["from"].setValue(null);
        this.mechanicFormArray["controls"][index]["controls"]["from"].setValue(val);
      }
    });

    let max = new FormControl(data?._purchase_max || null, Validators.compose([Validators.min(1), Validators.maxLength(3), this.helper.validateNumbersOnly, Validators.required, this.helper.greaterThanMin]));
    max.valueChanges.subscribe((value) => {
      if((value && this.mechanicFormArray["controls"][index]["controls"]["min"].value) && (value < this.mechanicFormArray["controls"][index]["controls"]["min"].value)) {
        let val = _.cloneDeep(this.mechanicFormArray["controls"][index]["controls"]["min"].value);
        this.mechanicFormArray["controls"][index]["controls"]["min"].setValue(null);
        this.mechanicFormArray["controls"][index]["controls"]["min"].setValue(val);
      } 
      //update display value if correct
      else if (value >= this.mechanicFormArray["controls"][index]["controls"]["min"].value) {
        let val = _.cloneDeep(this.mechanicFormArray["controls"][index]["controls"]["min"].value);
        this.mechanicFormArray["controls"][index]["controls"]["min"].setValue(null);
        this.mechanicFormArray["controls"][index]["controls"]["min"].setValue(val);
      }
    });

    let fromInfinite = new FormControl(null, []);
    fromInfinite.valueChanges.subscribe((value) => {
      if(value) {
        this.mechanicFormArray["controls"][index]["controls"]["from"].disable();
        this.mechanicFormArray["controls"][index]["controls"]["to"].disable();
        this.mechanicFormArray["controls"][index]["controls"]["from"].setValue(null, {emitEvent: false});
        this.mechanicFormArray["controls"][index]["controls"]["to"].setValue(null, {emitEvent: false});
        this.mechanicFormArray["controls"][index]["controls"]["toInfinite"].setValue(true, {emitEvent: false});
      } else {
        this.mechanicFormArray["controls"][index]["controls"]["from"].enable();
      }
    });

    let toInfinite = new FormControl(null, []);
    toInfinite.valueChanges.subscribe((value) => {
      if(value) {
        this.mechanicFormArray["controls"][index]["controls"]["to"].disable();
        this.mechanicFormArray["controls"][index]["controls"]["to"].setValue(null, {emitEvent: false});
      } else {
        this.mechanicFormArray["controls"][index]["controls"]["from"].enable();
        this.mechanicFormArray["controls"][index]["controls"]["to"].enable();
        this.mechanicFormArray["controls"][index]["controls"]["fromInfinite"].setValue(false, {emitEvent: false});
      }
    });

    let minInfinite = new FormControl(null, []);
    minInfinite.valueChanges.subscribe((value) => {
      if(value) {
        this.mechanicFormArray["controls"][index]["controls"]["min"].disable();
        this.mechanicFormArray["controls"][index]["controls"]["max"].disable();
        this.mechanicFormArray["controls"][index]["controls"]["min"].setValue(null, {emitEvent: false});
        this.mechanicFormArray["controls"][index]["controls"]["max"].setValue(null, {emitEvent: false});
        this.mechanicFormArray["controls"][index]["controls"]["maxInfinite"].setValue(true, {emitEvent: false});
      } else {
        this.mechanicFormArray["controls"][index]["controls"]["min"].enable();
      }
    });

    let maxInfinite = new FormControl(null, []);
    maxInfinite.valueChanges.subscribe((value) => {
      if(value) {
        this.mechanicFormArray["controls"][index]["controls"]["max"].disable();
        this.mechanicFormArray["controls"][index]["controls"]["max"].setValue(null, {emitEvent: false});
      }  
      else {
        this.mechanicFormArray["controls"][index]["controls"]["min"].enable();
        this.mechanicFormArray["controls"][index]["controls"]["max"].enable();
        this.mechanicFormArray["controls"][index]["controls"]["minInfinite"].setValue(false, {emitEvent: false});
      }
    });

    let formGroup = this.fb.group({
      id: data?._id || null,

      sequence: new FormControl(data?._sequence || index+1, Validators.compose([Validators.min(1), Validators.maxLength(2), this.helper.validateNumbersOnly, Validators.required])),

      from: new FormControl(data?._mechanic_period_from_qty || null, Validators.compose([Validators.min(1), Validators.maxLength(3), this.helper.validateNumbersOnly, Validators.required, this.helper.greaterThanTo])),

      to: to,

      min: new FormControl(data?._purchase_min || null, Validators.compose([Validators.min(1), Validators.maxLength(3), this.helper.validateNumbersOnly, Validators.required, this.helper.greaterThanMax])),

      max: max,

      discount: this.formGroupDescription.get('discountTypeSelect').value == "1" ? new FormControl(data?._discount_value || null, Validators.compose([Validators.min(0.01), Validators.max(1000), this.helper.decimalTwoPlaces, this.helper.validateNumbersDecimalPoint, Validators.required])) : new FormControl(data?._discount_value || null, Validators.compose([Validators.min(0.01), Validators.max(100), this.helper.validateNumbersOnly, Validators.required])),

      fromInfinite: fromInfinite,
      toInfinite: toInfinite,
      minInfinite: minInfinite,
      maxInfinite: maxInfinite
    });
    return formGroup;
  }

  addItem(mode, data=null): void {
    let addedRow = new DistributionPromoMechanic();
    if(data) {
      addedRow = data;
    }
    
    this.conditionDetailRows = this.conditionDetailRows.concat(addedRow);
    let formControlIndex = this.conditionDetailRows.length - 1;
    let newFormGroup = this.createItem(formControlIndex, data);
    (this.mechanicForms.controls.items as FormArray).push(newFormGroup);

    if(!mode) {
      this.toggleInfiniteCheckboxes(formControlIndex);
    }
  }

  toggleInfiniteCheckboxes(formControlIndex) {
    let val = this.isSelectedDiscountTierNone;

    this.mechanicFormArray["controls"][formControlIndex]["controls"]["fromInfinite"].setValue(val);
    this.mechanicFormArray["controls"][formControlIndex]["controls"]["toInfinite"].setValue(val);
    this.mechanicFormArray["controls"][formControlIndex]["controls"]["minInfinite"].setValue(val);
    this.mechanicFormArray["controls"][formControlIndex]["controls"]["maxInfinite"].setValue(val);
    
    if(val) {
      this.mechanicFormArray["controls"][formControlIndex]["controls"]["fromInfinite"].disable();
      this.mechanicFormArray["controls"][formControlIndex]["controls"]["toInfinite"].disable();
    }
    else {
      this.mechanicFormArray["controls"][formControlIndex]["controls"]["fromInfinite"].enable();
      this.mechanicFormArray["controls"][formControlIndex]["controls"]["toInfinite"].enable();
    }
    if(this.formGroup.get('nthPiece').value != 1){
      this.mechanicFormArray["controls"][formControlIndex]["controls"]["min"].setValue(this.formGroup.get('nthPiece').value);
      this.mechanicFormArray["controls"][formControlIndex]["controls"]["min"].setValidators([
        Validators.min(this.formGroup.get('nthPiece').value), 
        Validators.maxLength(3), 
        this.helper.validateNumbersOnly, 
        Validators.required, 
        this.helper.greaterThanMax
      ])
      this.mechanicFormArray["controls"][formControlIndex]["controls"]["minInfinite"].setValue(false);
      this.mechanicFormArray["controls"][formControlIndex]["controls"]["minInfinite"].disable();
    }
  }

  public edit(condition, idx, details, control) {

    console.log("EDIT !")

    this.initDefaultOptionSku()
    this.initDefaultOptionBrand()

    this.editMode = true;
    this.conditionDetailRows = [];
    this.chipList.errorState = false;

    const distributionPromoDetail = condition.distribution_promo_detail[idx];
    const distributionPromoSkus = _.get(distributionPromoDetail, 'distribution_promo_sku');
    const distributionPromoBrands = _.get(distributionPromoDetail, 'distribution_promo_brand');    

    this.promoDetails = _.filter(this.promoDetails, val => {
      if (val["temp_id"] != condition.distribution_promo_detail[idx]["temp_id"]) {
        return true
      } else if (condition.distribution_promo_detail[idx]["temp_id"] == null) {
        return true
      } else {
        return false
      }
    })

    for (let indx in condition.details) {
      this.conditionDetailRows = this.conditionDetailRows.concat(
        condition.details[indx]
      );
    }

    // Set multiSelects with data from distributionPromoDetail and set as selected
    this.multiSelect['selectedBrands'] = distributionPromoBrands;
    this.multiSelect['selectedItems'] = distributionPromoSkus;
    this.multiSelect['selectedBrands'].forEach(e =>{ e.selected = true});
    this.multiSelect['selectedItems'].forEach(e => e.selected = true);

    if (this.brands.length && this.multiSelect['selectedBrands'].length) {
      this.checkSelectedGeneric(this.brands, 'selectedBrands', 'brand');
    }

    // FOR IMPROVEMENT?? Check selected only if has values
    // Added this since there is a scenario that when BRANDS is selected in STEP 2, "this.items" is not populated
    if (this.items.length && this.multiSelect['selectedItems'].length) {
      this.checkSelectedGeneric(this.items, 'selectedItems', 'sku');
    }

    // Update form group with data from distributionPromoDetail
    const dateRangeFrom = _.get(distributionPromoDetail, 'use_distribution_start_end_date') == 1 ? _.get(this.distribution, 'start_date') : _.get(distributionPromoDetail, 'start_date');
    const dateRangeTo = _.get(distributionPromoDetail, 'use_distribution_start_end_date') == 1 ? _.get(this.distribution, 'end_date') : _.get(distributionPromoDetail, 'end_date');

    this.formGroup.controls["id"].setValue(distributionPromoDetail["id"]);
    this.formGroup.controls["temp_id"].setValue(distributionPromoDetail["temp_id"]);
    this.formGroup.controls["description"].setValue(distributionPromoDetail["description"]);
    this.formGroup.controls["resetPeriodNo"].setValue(distributionPromoDetail["capacity_reset_period_qty"]);
    this.formGroup.controls["resetPeriod"].setValue(distributionPromoDetail["capacity_reset_period"]);
    this.formGroup.controls["resetDay"].setValue(distributionPromoDetail["capacity_reset_day"]);
    this.formGroup.controls["priority"].setValue(distributionPromoDetail["priority"]);
    this.formGroup.controls["capInfinite"].setValue(distributionPromoDetail["capacity"] <= 0 ? true : false);
    this.formGroup.controls["cap"].setValue(distributionPromoDetail["capacity"] > 0 ? distributionPromoDetail["capacity"] : "Infinite");
    this.formGroup.controls["nthPiece"].setValue(distributionPromoDetail["apply_for_every_nth_pcs"]);
    this.formGroup.controls["applyDiscountTo"].setValue(distributionPromoDetail["apply_discount_to"]);
    this.formGroup.controls["useDistributionDates"].setValue(_.get(distributionPromoDetail, 'use_distribution_start_end_date'), {emitEvent: false});
    this.formGroup.controls["dateRangeFrom"].setValue(dateRangeFrom);
    this.formGroup.controls["dateRangeTo"].setValue(dateRangeTo);
    this.formGroup.controls["periodTier"].setValue(_.get(distributionPromoDetail, "mechanic_period") || "None");
    
    // SKU and Brand form controls
    if(this.displayAllItems(condition.distribution_promo_detail[idx].distribution_promo_brand,'brand')) {
      this.toggleSelection(_.cloneDeep(this.defaultOptionBrand), this.brands, 'selectedBrands', 'applyToBrand')
    }
    else {
      this.formGroup.controls["applyToBrand"].setValue(distributionPromoDetail["distribution_promo_brand"]);
    }

    console.log("this.displayAllItems(condition.distribution_promo_detail[idx].distribution_promo_sku,'item') "  + this.displayAllItems(condition.distribution_promo_detail[idx].distribution_promo_sku,'item'))

    if(this.displayAllItems(condition.distribution_promo_detail[idx].distribution_promo_sku,'item')) {
      this.toggleSelection(_.cloneDeep(this.defaultOptionSku), this.items, 'selectedItems', 'applyTo')
    }
    else {
      this.formGroup.controls["applyTo"].setValue(distributionPromoDetail["distribution_promo_sku"]);
    }

    // Disable fields 
    this.formGroup.get('description').disable({emitEvent: false});

    if (_.toLower(this.status) == 'ongoing' || this.did_generate == 1) {
      this.formGroup.get('resetPeriod').disable({emitEvent: false});
      this.formGroup.get('nthPiece').disable({emitEvent: false});
      this.formGroup.get('applyDiscountTo').disable({emitEvent: false});
      this.formGroup.get('periodTier').disable({emitEvent: false});
      this.formGroup.get('capInfinite').disable({emitEvent: false});
      this.formGroup.get('useDistributionDates').disable({emitEvent: false});
    }

    // Process mechanics
    this.setAndFillUpDynamicForms(distributionPromoDetail);
    
    // Auto scroll to "Detail" Panel
    this.scrollTo(document.getElementById("formWithAcordion"));
  }

  checkSelectedGeneric(srcArray, targetArray, prop) {
    let tempArr = [];
    this.multiSelect[targetArray].forEach(s => {
      srcArray.forEach(e => {
        if(e[prop] && (s[prop].id == e[prop].id)) {
          e.selected = true;
          tempArr.push(e);
        }
      })
    })
    this.multiSelect[targetArray] = tempArr;
  }

  checkSelectedItem(srcArray, prop) {
    let tempArr = [];
    this.multiSelect['selectedItems'].forEach(s => {
      srcArray.forEach(e => {
        if(e[prop] && (s[prop].id == e[prop].id)) {
          e.selected = true;
          tempArr.push(e);
        }
      })
    })
    this.multiSelect['selectedItems'] = tempArr;
  }

  remove(index: number, item: DistributionPromoDetailSku, srcArray, targetArray, formControlName): void {
    if (index >= 0 && !item._is_all) {
      this.multiSelect[targetArray].splice(index, 1);
      item.selected = false;
    } 
    if(item._is_all) {
      this.multiSelect[targetArray].splice(index, 1);
      for(let i=0; i< srcArray.length; i++) {
        srcArray[i].selected = false;
        srcArray[i].disabled = false;
      }
    }
    this.formGroup.get(formControlName).setValue(this.multiSelect[targetArray]);
  }

  private scrollTo(element: Element) {
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      if (!this.expansionPanel.expanded) {
        this.expansionPanel.open();
      }
    }
  }

  // Called upon ngOnInit and in campaign-wizard component as of 11/26/25 
  // NOTE: Ray
  // Buggy block, this is called twice
  //  - in onInit()
  //  - in campaign-wizard.component.ts func prepareStepTwoData
  // Causes two subscription of formControl listeners (check value changes)
  public setDropDownOptions() {
    this.maxSKUresetPeriod = this.constants.MAX_SKU_RESET_PERIOD;
    this.discountTypes = this.constants.DISCOUNT_TYPES;
    this.roundingOptions = this.constants.ROUDING_OPTIONS;
    this.defaultRounding = this.roundingOptions[0].value;
    this.resetDayOptions = this.constants.RESET_DAY_OPTIONS;
    this.applyDiscountToOption = this.constants.APPLY_DISCOUNT_TO_OPTIONS;
    this.tierBaseDiscountoptions = this.constants.TIER_BASE_DISCOUNT_OPTIONS;
    this.periodTierOptions = this.constants.PERIOD_TIER_OPTIONS;

    this.setFilteredOptions('item')
    this.setFilteredOptions('brand')

    this.formGroupDescription.get('maxSKUresetPeriod').valueChanges.subscribe(value => {
      if(_.toLower(value) == 'none') {
        this.formGroupDescription.get('maxSKUResetPeriodQty').disable();
      }
      else {
        this.formGroupDescription.get('maxSKUResetPeriodQty').enable();
      }
    });

    this.formGroupDescription.get('discountTypeSelect').valueChanges.subscribe(value => {
      if(_.toLower(value) == '1') {
        this.formGroupDescription.get('discountRateSelect').disable();
        this.formGroupDescription.get('decimal').disable();
      }
      else {
        this.formGroupDescription.get('discountRateSelect').enable();
        this.formGroupDescription.get('decimal').enable();
      }
    });

    this.formGroup.get('capInfinite').valueChanges.subscribe(value => {
      if(value) {
        this.formGroup.get('cap').disable();
        this.formGroup.get('cap').setValue("Infinite");
      }
      else {
        this.formGroup.get('cap').enable();
        this.formGroup.get('cap').setValue(_.get(this.condition, 'distribution_promo_detail[0].capacity', 0) > 0 ? _.get(this.condition, 'distribution_promo_detail[0].capacity') : null);
      }
    });

    this.formGroup.get('resetPeriod').valueChanges.subscribe(value => {
      if(_.toLower(value) == 'none') {
        this.formGroup.get('resetPeriodNo').disable();
        this.formGroup.get('resetDay').disable();
        this.resetDayOptions = this.constants.RESET_DAY_OPTIONS;
        this.formGroup.get('resetDay').setValue(this.resetDayOptions[0].value);
      }
      else {
        this.formGroup.get('resetPeriodNo').enable();
        this.formGroup.get('resetPeriodNo').setValidators([Validators.required]);
        this.formGroup.get('resetDay').enable();
        this.formGroup.get('resetDay').setValue(null);
        this.resetDayOptions = this.constants.RESET_DAY_OPTIONS.filter(e => {
          return e.value != "None"
        });
      }
    });

    this.formGroup.get('useDistributionDates').valueChanges.subscribe(value => {
      if(value) {
        this.formGroup.get('dateRangeFrom').setErrors(null);
        this.formGroup.get('dateRangeTo').setErrors(null);
        this.formGroup.get('dateRangeFrom').markAsUntouched();
        this.formGroup.get('dateRangeTo').markAsUntouched();
      }
      else if (!value){
        this.formGroup.get('dateRangeFrom').setValidators([Validators.required]);
        this.formGroup.get('dateRangeTo').setValidators([Validators.required]);
      }
    });
    
    if (_.get(this.distribution, 'distribution_sku_mode') == 'CATEGORY') {
      // Populate data for the Apply to Brand/s dropdown
      this.getData('brand')
    }

    if (_.get(this.distribution, 'distribution_sku_mode') != 'SKU') {
      this.formGroup.get("applyToBrand").valueChanges.pipe(
        debounceTime(600),
        // distinctUntilChanged(),
      ).subscribe(value => {
        this.items = []
        this.filteredItems = null;
        this.getData('item');
      });
    }
  }

  private listParameter: {brand:[],category:[],item:[]} | undefined

  // Store multi-select data from stepper two, Brand, Category, Item
  public setStepTwoData(listParameter: {brand:[],category:[],item:[]}) {
    this.listParameter = listParameter
  }

  // Called in campaign-wizard.component.ts func prepareStepTwoData 
  public setSourceData(listParameter: {brand:[],category:[],item:[]}) {
    this.getSourceData('brand',listParameter)
    this.getSourceData('item',listParameter)
  }

  setFilteredOptions(type) {
    switch(type) {
      case 'brand': 
        this.filteredBrands = this.formGroup.get("applyToBrandInput").valueChanges.pipe(
          startWith<string | DistributionPromoDetailSku[]>(""),
          map(value => (typeof value === "string" ? value : this.lastFilter)),
          map(filter => this.filter(this.brands, filter))
        );
        break;
      case 'item':
        this.filteredItems = this.formGroup.get("applyToInput").valueChanges.pipe(
          startWith<string | DistributionPromoDetailSku[]>(""),
          map(value => (typeof value === "string" ? value : this.lastFilter)),
          map(filter => this.filter(this.items, filter))
        );
        break;
    }
  }

  private filter(srcArray, filter): DistributionPromoDetailSku[] {
    this.lastFilter = filter;
    if (filter) {
      return srcArray.filter(option => {
        let desc = _.get(option, 'sku.description') || _.get(option, 'category.description') || _.get(option, 'brand.description')
        return desc.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
      });
    } else {
      return srcArray.slice();
    }
  }

  private optionClicked(event: Event, item: DistributionPromoDetailSku, srcArray, targetArray, formControlName) {
    event.stopPropagation();
    this.toggleSelection(item, srcArray, targetArray, formControlName);
  }

  private toggleSelection(item: DistributionPromoDetailSku, srcArray, targetArray:'selectedItems'|'selectedBrands', formControlName:'applyTo'|'applyToBrand') {
    this.formGroup.get(formControlName).setValue("");

    if (item._is_all) {
      item.selected = !item.selected;
      if (item.selected) {
        this.multiSelect[targetArray] = [];
        for (let a of srcArray) {
          a.selected = true;
          if(!a._is_all) {
            a.disabled = true;
          }
        }
        this.multiSelect[targetArray].push(item);
      } else {
        this.multiSelect[targetArray] = [];
        for (let a of srcArray) {
          a.selected = false;
          a.disabled = false;
        }
        this.multiSelect[targetArray].splice(this.multiSelect[targetArray].indexOf(item), 1);
      }
    } else {
      item.selected = !item.selected;
      if (item.selected) {
        this.multiSelect[targetArray].push(item);
      } else {
        this.multiSelect[targetArray].splice(this.multiSelect[targetArray].indexOf(item), 1);

        if (srcArray[0].selected == true) {
          for (let a of srcArray) {
            a.selected = false;
          }
        }
      }
    }

    this.formGroup.get(formControlName).setValue(this.multiSelect[targetArray]);
    this.chipList.errorState = false;
  }

  private validateItems(temp_id: number, items: DistributionPromoDetailSku[]): Boolean {
    // note di ko alam kng pano ko napaga na
    if (this.condition._distribution_promo_detail) {
      if (this.condition._distribution_promo_detail["distribution_promo_sku"]) {
        for (let itemToAdd of items) {
          let ctr = 0;
          if (this.condition._distribution_promo_detail["distribution_promo_sku"].length == items.length) {
            for (let itemInCondition of this.condition._distribution_promo_detail["distribution_promo_sku"]) {
              for (let i of items) {
                if (
                  i._sku._description == itemInCondition.name ||
                  i._brand._description == itemInCondition.name ||
                  i._category._description == itemInCondition.name
                ) {
                  ctr++;
                }
              }
            }
            if (ctr == this.condition._distribution_promo_detail["distribution_promo_sku"].length) {
              return true;
            } else {
              return false;
            }
          } else {
            for (let itemInCondition of this.condition._distribution_promo_detail["distribution_promo_sku"]) {
              if (
                itemToAdd._sku._description == itemInCondition.name ||
                itemToAdd._brand._description == itemInCondition.name ||
                itemToAdd._category._description == itemInCondition.name
              ) {
                return false;
              }
            }
          }
        }
      }

      // validation of duplicate items across multiple promo mechanics
      for (let promoDetail of this.promoDetails) {
        if (temp_id && temp_id == promoDetail._temp_id) {
          continue;
        }
        if (promoDetail._distribution_promo_sku) {
          for (let sku of promoDetail._distribution_promo_sku) {
            for (let item of items) {
              if (sku._sku?._id == item._sku?._id) {
                return false;
              }
            }
          }
        }
      }
    }
    return true;
  }

  // Unused as of 11/26/25 
  copyOutput(details: DistributionPromoDetail) {

    if(details) {
      details["distribution_promo_mechanic"].forEach(e => {
        e["id"] = 0;
      })
      details["distribution_promo_sku"].forEach(e => {
        e["id"] = 0;
        e["distribution_promo_detail_id"] = 0;
      })
      this.multiSelect['selectedItems'] = details._distribution_promo_sku;
      this.formGroup.controls["description"].setValue(details._description);
      this.formGroup.controls["applyTo"].setValue(details._distribution_promo_sku);
      this.formGroup.controls["resetPeriodNo"].setValue(details._capacity_reset_period_qty);
      this.formGroup.controls["resetPeriod"].setValue(details._capacity_reset_period);
      this.formGroup.controls["resetDay"].setValue(details._capacity_reset_day);
      this.formGroup.controls["priority"].setValue(details._priority);
      this.formGroup.controls["cap"].setValue(details._capacity);
      this.formGroup.controls["nthPiece"].setValue(details._apply_for_every_nth_pcs);
      this.formGroup.controls["applyDiscountTo"].setValue(details._apply_discount_to);
      this.formGroup.controls["periodTier"].setValue(details._mechanic_period);
      this.formGroup.controls["useDistributionDates"].setValue(details._is_distribution_date);
      this.formGroup.controls["dateRangeFrom"].setValue(details._start_date);
      this.formGroup.controls["dateRangeTo"].setValue(details._end_date);
      this.setAndFillUpDynamicForms(details);
    }
    else {
      this.multiSelect['selectedItems'] = [];
      this.formGroup.controls["description"].setValue(null);
      this.formGroup.controls["applyTo"].setValue(null);
      this.formGroup.controls["resetPeriodNo"].setValue(null);
      this.formGroup.controls["resetPeriod"].setValue(this.constants.MAX_SKU_RESET_PERIOD[0].value);
      this.formGroup.controls["resetDay"].setValue(this.constants.RESET_DAY_OPTIONS[0].value);
      this.formGroup.controls["priority"].setValue(null);
      this.formGroup.controls["cap"].setValue("Infinite");
      this.formGroup.controls["capInfinite"].setValue(true);
      this.formGroup.controls["nthPiece"].setValue(1);
      this.formGroup.controls["applyDiscountTo"].setValue(this.constants.APPLY_DISCOUNT_TO_OPTIONS[0].value);
      this.formGroup.controls["periodTier"].setValue(this.constants.MAX_SKU_RESET_PERIOD[0].value);
      this.formGroup.controls["useDistributionDates"].setValue(true);
      this.formGroup.controls["dateRangeFrom"].setValue(null);
      this.formGroup.controls["dateRangeTo"].setValue(null);
      this.conditionDetailRows = [];
      this.mechanicFormArray.controls = [];

      let sku = new Sku();
      sku._id = 0;
      sku._description = "All";
      let item = new DistributionPromoDetailSku(0, 0, null, null, sku, false);
      item._is_all = true;
      item.selected = true;
      this.toggleSelection(item, this.items, 'selectedItems', 'applyTo');
    }
  }

  setAndFillUpDynamicForms(details) {
    this.conditionDetailRows = [];
    this.mechanicForms.controls.items["controls"] = [];

    if(_.has(details, 'distribution_promo_mechanic')) {
      for (let mech in details._distribution_promo_mechanic) {
        this.addItem('editMechanic', mech);
      }
    }

    for (let index in this.mechanicForms.controls.items["controls"]) {
      this.mechanicForms.controls.items["controls"][index]["controls"]["id"].setValue(_.get(details, 'distribution_promo_mechanic' + [index] + '._id') || _.get(details.distribution_promo_mechanic[index], 'id') || 0);

      this.mechanicForms.controls.items["controls"][index]["controls"]["sequence"].setValue(_.get(details, 'distribution_promo_mechanic' + [index] + '._sequence') || _.get(details.distribution_promo_mechanic[index], 'sequence'));

      //check if _mechanic_period_from_qty value is -1
      if((_.get(details, 'distribution_promo_mechanic' + [index] + 'mechanic_period_from_qty') == -1) || (_.get(details.distribution_promo_mechanic[index], 'mechanic_period_from_qty') == -1)) {
        this.mechanicForms.controls.items["controls"][index]["controls"]["fromInfinite"].setValue(true, {emitEvent: false});
        this.mechanicForms.controls.items["controls"][index]["controls"]["from"].disable();

        //enable infinite checkbox
        if(_.get(details, 'mechanic_period')) {
          this.mechanicForms.controls.items["controls"][index]["controls"]["fromInfinite"].enable();
        }

      } else {
        this.mechanicForms.controls.items["controls"][index]["controls"]["from"].setValue(_.get(details, 'distribution_promo_mechanic' + [index] + '._mechanic_period_from_qty') || _.get(details.distribution_promo_mechanic[index], 'mechanic_period_from_qty'));
      }

      //check if _mechanic_period_to_qty value is -1
      if((_.get(details, 'distribution_promo_mechanic' + [index] + 'mechanic_period_to_qty') == -1) || (_.get(details.distribution_promo_mechanic[index], 'mechanic_period_to_qty') == -1)) {
        this.mechanicForms.controls.items["controls"][index]["controls"]["toInfinite"].setValue(true, {emitEvent: false});
        this.mechanicForms.controls.items["controls"][index]["controls"]["to"].disable();

        //enable infinite checkbox
        if(_.get(details, 'mechanic_period')) {
          this.mechanicForms.controls.items["controls"][index]["controls"]["toInfinite"].enable();
        }

      } else {
        this.mechanicForms.controls.items["controls"][index]["controls"]["to"].setValue(_.get(details, 'distribution_promo_mechanic' + [index] + '._mechanic_period_to_qty') || _.get(details.distribution_promo_mechanic[index], 'mechanic_period_to_qty'));
      }

      //check if _purchase_min value is -1
      if((_.get(details, 'distribution_promo_mechanic' + [index] + 'purchase_min') == -1) || (_.get(details.distribution_promo_mechanic[index], 'purchase_min') == -1)) {
        this.mechanicForms.controls.items["controls"][index]["controls"]["minInfinite"].setValue(true, {emitEvent: false});
        this.mechanicForms.controls.items["controls"][index]["controls"]["min"].disable();
      } else {
        this.mechanicForms.controls.items["controls"][index]["controls"]["min"].setValue(_.get(details, 'distribution_promo_mechanic' + [index] + '._purchase_min') || _.get(details.distribution_promo_mechanic[index], 'purchase_min'));
      }

      //check if _purchase_max value is -1
      if((_.get(details, 'distribution_promo_mechanic' + [index] + 'purchase_max') == -1) || (_.get(details.distribution_promo_mechanic[index], 'purchase_max') == -1)) {
        this.mechanicForms.controls.items["controls"][index]["controls"]["maxInfinite"].setValue(true, {emitEvent: false});
        this.mechanicForms.controls.items["controls"][index]["controls"]["max"].disable();
      } else {
        this.mechanicForms.controls.items["controls"][index]["controls"]["max"].setValue(_.get(details, 'distribution_promo_mechanic' + [index] + '._purchase_max') || _.get(details.distribution_promo_mechanic[index], 'purchase_max'));
      }

      this.mechanicForms.controls.items["controls"][index]["controls"]["discount"].setValue(_.get(details, 'distribution_promo_mechanic' + [index] + '._discount_value') || _.get(details.distribution_promo_mechanic[index], 'discount_value'));
    }
    console.log(this.mechanicForms.controls)
  }

  displayFn(data?: any): string | undefined {
    if(data) {
      return _.get(data, 'code') + ' - ' + _.get(data, 'description');
    }
    return null;
  }

  displayAllItems(list, listType: 'brand'|'item') {
    switch(listType) {
      case 'brand':
        return list.length == this.originalSourceBrand.length;
      case 'item':        
        // Make this a function? Also performed similarly in buildPromoDetailForAddItem
        const filteredItems = [];
        for (const item of this.originalSourceItem) {
          // Filter out items under the selected brands
          const itemBrandId = item.brand.id;
  
          // Only filter if there are selected brands and not "all"
          const shouldFilterByBrand = this.multiSelect['selectedBrands'].length > 0 && this.multiSelect['selectedBrands'][0].brand.id !== 0;
  
          const exists = shouldFilterByBrand
            ? this.multiSelect['selectedBrands'].some(b => b.brand.id === itemBrandId)
            : true; // if no selected brands, always include
  
          if (exists) {
            filteredItems.push(item);
          }
        }

        return list.length == filteredItems.length;
      default:
        return false;
    }
  }

  autocompleteScroll(name, refName, acTrigger) {
    setTimeout(() => {
      if (this[refName].isOpen || this[refName].panel) {
        fromEvent(this[refName].panel.nativeElement, 'scroll')
          .pipe(
            map(x => this[refName].panel.nativeElement.scrollTop),
            takeUntil(this[acTrigger].panelClosingActions)
          )
          .subscribe(x => {
            const scrollTop = this[refName].panel.nativeElement
              .scrollTop;
            const scrollHeight = this[refName].panel.nativeElement
              .scrollHeight;
            const elementHeight = this[refName].panel.nativeElement
              .clientHeight;
            const atBottom = scrollHeight === scrollTop + elementHeight;
            if (atBottom) {
              // fetch more data
              // this.getMoreData(name);
            }
          });
      }
    });
  }

  removeMechanic(mechanic) {
    this.mechanicFormArray.removeAt(this.mechanicFormArray.value.findIndex(t => t["sequence"] == _.get(mechanic, 'value.sequence')))
    for(let i of this.conditionDetailRows) {

    }
    this.conditionDetailRows.splice(_.get(mechanic, 'value.sequence')-1, 1);
    if (_.isEmpty(this.conditionDetailRows)) {
      this.formGroup.get('nthPiece').enable();
      this.formGroupDescription.get('discountTypeSelect').enable();
      this.formGroupDescription.get('discountTier').enable();
      this.formGroupDescription.get('mechanicPeriodBasis').enable();
    }
  }

  getData(name) {
    let filters = _.cloneDeep(this.filters)
    this.filters.getMore = false;
    this.loading[name] = true;

    switch (name) {
      case 'brand': {
        this.brands = []; 

        // This could be improved/implemented better:
        // Scenario is when ALL categories is selected in step 2 (refer to ticket)
        // const selectedCategoryIds = this.categories
        //   .filter(item => item.selected && item.category)
        //   .map(item => item.category.id);

        filters.web_filter["limit"] = 999999
          
        // If any selected id is 0 → override to [0]
        // if (selectedCategoryIds.includes(0)) {
        //   filters.web_filter["category_ids"] = [0];
        // } else {
        //   filters.web_filter["category_ids"] = selectedCategoryIds.length ? selectedCategoryIds : [0];
        // }

        filters.web_filter["category_ids"] = this.listParameter.category
        filters.web_filter["brand_ids"] = this.listParameter.brand

        this.campaignsService.getWizardBrands(filters).pipe(
          tap(() => this.loading.brand = true),
          finalize(() => {
            this.loading.brand = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.brand = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.loading.brand = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
              this.loading.error = true;
              this.brands = [];
              this.filteredBrands = null;
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              if(!filters.web_filter.keyword) {
                this.brands[0] = this.defaultOptionBrand;
              }

              for (let datum of _.get(res, 'data')) {
                let brand = new Brand(datum.id, datum.description);
                let brandOpt: DistributionPromoDetailSku = new DistributionPromoDetailSku(0, 0, null, brand, null);
                this.brands = this.brands.concat(brandOpt);
              }

              this.setFilteredOptions('brand');
              this.checkSelectedGeneric(this.brands, 'selectedBrands', 'brand');

              if((res.data.length > 0) && (this.brands.length < _.get(res, 'count'))) {
                this.filters.getMore = true;
              }
            }
          });
          break;
      }

      case 'item': {
        this.items = [];

        const selectedBrandIds = this.brands
          .filter(item => item.selected && item.brand && !item._is_all)
          .map(item => item.brand.id);

        filters.web_filter["category_ids"] = this.listParameter.category;
        filters.web_filter["brand_ids"] = selectedBrandIds.length ? selectedBrandIds : [0]; // Network connection error is encountered when [] is passed
        filters.web_filter["sku_ids"] = this.listParameter.item;
        filters.web_filter["limit"] = 999999

        this.campaignsService.getItems(filters).pipe(
          tap(() => this.loading.item = true),
          finalize(() => {
            this.loading.item = false;
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            this.loading.item = false;
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            this.loading.item = false;
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
              this.loading.error = true;
              this.items = [];
              this.filteredItems = null;
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              if(!filters.web_filter.keyword) {
                this.items[0] = this.defaultOptionSku;
              }

              const currentlySelectedItems = this.multiSelect.selectedItems
              const isSetToAll = this.multiSelect.selectedItems.some(item => item._is_all);

              for (let datum of _.get(res, 'data')) {
                let item = new Sku(datum.id, datum.description);
                let itemOpt: DistributionPromoDetailSku = new DistributionPromoDetailSku(0, 0, null, null, item);
                itemOpt.selected = isSetToAll || currentlySelectedItems.some(item => item._sku && item._sku.id == datum.id);
                itemOpt.disabled = isSetToAll
                this.items = this.items.concat(itemOpt);
              }

              this.setFilteredOptions('item');
              this.checkSelectedGeneric(this.items, 'selectedItems', 'sku');

              if((res.data.length > 0) && (this.items.length < _.get(res, 'count'))) {
                this.filters.getMore = true;
              }
            }
        });
      }
    }
  }

  // This is purely for 'All' handling in applyTo and applyToBrand 
  getSourceData(name:'brand'|'item', listParameter: {brand:[],category:[],item:[]}) {
    let filters = _.cloneDeep(INITIAL_OPTIONS)
    switch (name) {
      case "brand": {
        // This could be improved/implemented better:
        // Scenario is when ALL categories is selected in step 2 (refer to ticket)
        const selectedCategoryIds = this.categories.filter(item => item.selected && item.category).map(item => item.category.id);
        filters.web_filter["limit"] = 999999
          
        // If any selected id is 0 → override to [0]
        filters.web_filter["category_ids"] = listParameter.category;
        filters.web_filter["brand_ids"] = listParameter.brand;

        this.campaignsService.getWizardBrands(filters).pipe(
          finalize(() => {
            return observableOf(null);
          }),
          catchError((err) => {
            console.error(err);
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
              this.originalSourceBrand = [];
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              this.originalSourceBrand = []
              for (let datum of _.get(res, 'data')) {
                let brand = new Brand(datum.id, datum.description);
                let brandOpt: DistributionPromoDetailSku = new DistributionPromoDetailSku(0, 0, null, brand, null);
                this.originalSourceBrand = this.originalSourceBrand.concat(brandOpt);
              }
            }
          });
          break;
      }

      case 'item': {
        filters.web_filter["category_ids"] = listParameter.category;
        filters.web_filter["brand_ids"] = listParameter.brand;
        filters.web_filter["sku_ids"] = listParameter.item;
        filters.web_filter["limit"] = 999999

        this.campaignsService.getItems(filters).pipe(
          finalize(() => {
            return observableOf(null);
          }),
          catchError((err) => {
            return observableOf(null);
          }))
          .subscribe((res: any) => {
            if (environment.showLogs) {
              console.log(res);
            }
            if (res == null || res.status == 0 || res.status == 400 || res.status == 500 || res.status == 502 || res.status == 504) {
              this.originalSourceItem = [];
              this.dialogService.openSnackBar(this.networkErrMsg)
              return;
            }
            if (_.has(res, 'value') && (res.value == "Success")) {
              this.originalSourceItem = []
              for (let datum of _.get(res, 'data')) {
                const brand = new Brand(datum.brand.id, datum.brand.description);
                const item = new Sku(datum.id, datum.description);
                const itemOpt: DistributionPromoDetailSku = new DistributionPromoDetailSku(0, 0, null, brand, item);

                this.originalSourceItem = this.originalSourceItem.concat(itemOpt);
              }
            }
        });
      }
    }
  }

  checkSelected(type, srcArray, targetArray, formControlName) {
    if(this.multiSelect[targetArray].some(opt => opt.description == 'All')) {
      let tempObj 
      switch (type) {
        case 'items':
          tempObj = _.cloneDeep(this.defaultOptionSku);
          break;
        case 'brands':
          tempObj = _.cloneDeep(this.defaultOptionBrand);
          break;
      }

      tempObj.selected = false;
      this.toggleSelection(tempObj, srcArray, targetArray, formControlName);
    } 
    else if (this.multiSelect[targetArray].length) {
      srcArray.forEach(e => {
        this.multiSelect[targetArray].forEach(v => {
          if(e.description == v.description) {
            e.selected = v.selected;
          }
        })
        if(e.description == 'All') {
          e.selected = false;
        }
      })
    } else {
      srcArray.forEach(e => {
        e.selected = false;
      })
    }
  }

  // Called once upon ngOnInit as of 11/26/25 
  initDefaultOptionSku() {
    let sku = new Sku(0, "All");
    let item = new DistributionPromoDetailSku(0, 0, null, null, sku, false);
    item._is_all = true;
    
    this.defaultOptionSku = item;
  }

  // Called once upon ngOnInit as of 11/26/25 
  initDefaultOptionBrand() {
    let brand = new Brand(0, "All");
    let item = new DistributionPromoDetailSku(0, 0, null, brand, null, false);
    item._is_all = true;
    
    this.defaultOptionBrand = item;
  }

  public get tierBaseDiscountSelect(): string {
    return this.formGroupDescription?.get('discountTier')?.value || 'None';
  }

  get isSelectedDiscountTierNone(): boolean {
    return this.tierBaseDiscountSelect === 'None';
  }

  get isSelectedDiscountTierTransactionCount(): boolean {
    return this.tierBaseDiscountSelect === 'transaction_count';
  }

  get isSelectedDiscountTierPeriod(): boolean {
    return this.tierBaseDiscountSelect === 'period';
  }
}

const INITIAL_OPTIONS = {
	web_filter: {
		limit: 50,
		offset: 0,
    keyword: "",
    status: null,
    order_by: "asc",
		is_asc: 1
	}
}